// Emission factor & sustainability types for the VoyagePlanner application

export interface EmissionFactor {
  id: number;
  vehicleType: string;      // Enum name, e.g. "Bus", "RentalCar"
  vehicleTypeName: string;  // Human-readable German name
  gramsCo2ePerPassengerKm: number;
  unit: string;
  source?: string;
  description?: string;
  validFrom?: string | null;
  validTo?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertEmissionFactorRequest {
  gramsCo2ePerPassengerKm: number;
  unit?: string;
  source?: string;
  description?: string;
  validFrom?: string | null;
  validTo?: string | null;
  isActive?: boolean;
}

export interface SustainabilityByVehicleType {
  vehicleType: string;
  segmentCount: number;
  distanceKm: number;
  co2eKg: number;
}

export interface SustainabilityByPlanning {
  planningId: number;
  name: string;
  date: string;
  segmentCount: number;
  distanceKm: number;
  co2eKg: number;
}

export interface SustainabilityReport {
  from: string;
  to: string;
  planningCount: number;
  segmentCount: number;
  totalDistanceKm: number;
  totalCo2eKg: number;
  segmentsWithoutFactor: number;
  byVehicleType: SustainabilityByVehicleType[];
  byPlanning: SustainabilityByPlanning[];
}

// Vehicle types available for emission factors (matches backend VehicleType enum names).
export const EMISSION_VEHICLE_TYPES: { value: string; label: string }[] = [
  { value: 'Bus', label: 'Bus' },
  { value: 'Minibus', label: 'Kleinbus' },
  { value: 'Car', label: 'PKW' },
  { value: 'Plane', label: 'Flugzeug' },
  { value: 'Train', label: 'Bahn' },
  { value: 'Taxi', label: 'Taxi' },
  { value: 'RentalCar', label: 'Mietwagen' },
  { value: 'Ship', label: 'Schiff' },
  { value: 'Bicycle', label: 'Fahrrad' },
  { value: 'OnFoot', label: 'Zu Fuß' }
];
